export const EMPTY_MSG_NO_PRODUCTS = 'No Products available'

export const EMPTY_MSG_WORKING_ON_RECOMMENDED_POLICIES =
  'We are working on recommended polices for you.'

export const EMPTY_MSG_WORKING_ON_OTHER_PRODUCTS =
  'We are working on other products for you.'

export const portFolioColumns = [
  'Year',
  'No. of Employee',
  'No. of Lives ',
  'Parents Included',
  'Premium Paid',
  'Claim settled',
  'ClaimsOutstanding',
  'Claims %',
]

export const DOWNLOAD_REPORTS_TITLE = 'Health Insurance Report(s)'

export const DOWNLOAD_REPORTS_TEXT = 'Download Reports'

export const CALL_TO_ACTION_TEXT = 'Please call me'

export const KEY_SUGGESTIONS = 'Key Suggestions'

export const CATEGORIES_AGE = [
  ['18-25', ''],
  ['26-35', ''],
  ['36-45', ''],
  ['46-55', ''],
  ['55-60', ''],
  ['60+', ''],
]

export const TREND_ANALYSIS_TEXT = 'Trend Analysis'

export const tableColumnOne = [
  { label: 'Turnover', value: 'turnOver' },
  { label: 'Premium', value: 'totalPremium' },
  { label: 'Claims', value: 'totalClaims' },
  { label: 'Claims Ratio(%)', value: 'claimsRatio' },
]
